import { img_path } from "../../../environment";

interface Image {
  className?: string;
  src: string;
  alt?: string;
  height?: number;
  width?: number;
  id?: string;
}

const ImageWithBasePath = (props: Image) => {
  // For Create React App, use PUBLIC_URL or default to root path
  const basePath = process.env.PUBLIC_URL || img_path || "/";

  // Ensure proper path concatenation
  const cleanBasePath = basePath.endsWith("/") ? basePath : basePath + "/";
  const cleanSrc = props.src.startsWith("/")
    ? props.src.substring(1)
    : props.src;

  const fullSrc = `${cleanBasePath}${cleanSrc}`;

  return (
    <img
      className={props.className}
      src={fullSrc}
      height={props.height}
      alt={props.alt}
      width={props.width}
      id={props.id}
      onError={(e) => {
        console.error(`Failed to load image: ${fullSrc}`);
        console.error(`Original src: ${props.src}`);
        console.error(`Base path: ${basePath}`);
      }}
    />
  );
};

export default ImageWithBasePath;
